/* eslint-disable linebreak-style */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
import _ from 'lodash';

const arrayTag = '[object Array]';
const objectTag = '[object Object]';
const stringTag = '[object String]';
const deepTag = [arrayTag, objectTag];

const forEach = (array, iteratee) => {
  let index = -1;

  const len = array.length;

  while (++index < len) {
    iteratee(array[index], index);
  }

  return array;
};

const getType = (target) => Object.prototype.toString.call(target);

export const cloneTrim = (target, map = new WeakMap()) => {
  const type = getType(target);

  let cloneTarget;

  if (deepTag.includes(type)) {
    cloneTarget = _.cloneDeep(target);
  } else if (type === stringTag) {
    return target.trim();
  } else {
    return target;
  }

  if (map.get(target)) {
    return target;
  }

  map.set(target, cloneTarget);

  const keys = type === arrayTag ? undefined : Object.keys(target);

  forEach(keys || target, (value, key) => {
    if (keys) {
      key = value;
    }

    cloneTarget[key] = cloneTrim(target[key], map);
  });

  return cloneTarget;
};
